export default __webpack_public_path__ + "static/media/blaq2.479ffab9.webp";